import React, { useEffect, useState } from "react";

const VCstatus = ({
  statusVc,
  isProgress,
  activeBt,
  scrollIntoCordProof2025,
  scrollIntoSignature,
  scrollIntoCordSDRProof,
}) => {
  const [inprogress, setInprogress] = useState("null");

  useEffect(() => {
    
    if (statusVc) {
      if (!isProgress) {
        setInprogress("second");
      }
      // const timeout2 = setTimeout(() => {
        setInprogress("third");
      // }, 4000);

      const timeout3 = setTimeout(() => {
        setInprogress("null");
      }, 4000);

      // Clear the timeouts to prevent memory leaks
      return () => {
        // clearTimeout(timeout2);
        clearTimeout(timeout3);
      };
    }
  }, [statusVc, isProgress]);

  return (
    <>
      {/* <span>
        <div
          className={`verify-body mt-2 ${
            statusVc && activeBt === "Ed25519Signature2020" ? "active" : ""
          } ${statusVc ? "" : " disabled"}`}
          onClick={() => {
            if (statusVc) {
              scrollIntoSignature();
            }
          }}
        >
          {!isProgress && !statusVc ? (
            <img
              className={`success-svg sign`}
              src="successdis.svg"
              alt="Loader"
            ></img>
          ) : isProgress && statusVc === undefined ? (
            <div className="loaderico">
              <div
                className="spinner-border spinner-border-sm loading-spin"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : statusVc ? (
            statusVc["Ed25519Signature2020"]?.isValid && !isProgress ? (
              <span className="divsvg">
              <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="23" cy="23" r="23" fill="none"/> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
              </svg>
              </span>
            ) : (
              <img
                className={`success-svg sign`}
                src="error.svg"
                alt="Loader"
              ></img>
            )
          ) : null}
          <div className="sign-body">
            <p className="d-flex flex-column">
              Issuer verified{" "}
              {statusVc &&
              !isProgress &&
              !statusVc["Ed25519Signature2020"].isValid &&
              statusVc["Ed25519Signature2020"].message ? (
                <span className="errortxt">
                  {statusVc["Ed25519Signature2020"].message}
                </span>
              ) : null}
            </p>
          </div>
        </div>
      </span> */}
      <span>
        <div
          className={`verify-body  mt-2 ${
            activeBt === "CordProof" ? "active" : ""
          }${statusVc && inprogress !== "second" ? "" : " disabled"}`}
          onClick={() => {
            if (statusVc) {
              scrollIntoCordProof2025();
            }
          }}
        >{console.log("StatusVc", statusVc)}
          {!statusVc ? (
                 <div className="loaderico">
                 <div
                   className="spinner-border spinner-border-sm loading-spin"
                   role="status"
                 >
                   <span className="sr-only">Loading...</span>
                 </div>
               </div>
          ) : inprogress === "second" && statusVc ? (
            <div className="loaderico">
              <div
                className="spinner-border spinner-border-sm loading-spin"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : statusVc && inprogress !== "second" ? (
            statusVc.CordProof2025?.isValid ? (
              <span className="divsvg">
              <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="23" cy="23" r="23" fill="none"/> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
              </svg>
              </span>
            ) : (
              <img
                className={`success-svg sign`}
                src="error.svg"
                alt="Loader"
              ></img>
            )
          ) : null}

          <div className="sign-body">
            <p className="d-flex flex-column">
              Cord validation{" "}
              {statusVc &&
              inprogress !== "second" &&
              !statusVc.CordProof2025.isValid &&
              statusVc.CordProof2025.message ? (
                <span className="errortxt">
                  {statusVc.CordProof2025.message}
                </span>
              ) : null}
            </p>
          </div>
        </div>
      </span>
      {/* CordSDRProof2024 */}
      <span>
        <div>
          <div
            className={`verify-body mt-1 ${
              activeBt === "CordSDRProof" ? "active" : ""
            }${
              statusVc && inprogress !== "second" && inprogress !== "third"
                ? ""
                : " disabled"
            }`}
            onClick={() => {
              if (statusVc) {
                scrollIntoCordSDRProof();
              }
            }}
          >
            {/* {!statusVc ? (
              <img
                className={`success-svg sign`}
                src="successdis.svg"
                alt="Loader"
              ></img>
            ) : inprogress === "third" && statusVc ? (
              <div className="loaderico">
                <div
                  className="spinner-border spinner-border-sm loading-spin"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : statusVc && inprogress === "null" ? (
              statusVc.CordSDRProof2024?.isValid ? (
                <span className="divsvg">
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle className="checkmark__circle" cx="23" cy="23" r="23" fill="none"/> <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
                </span>
              ) : (
                <img
                  className={`success-svg sign`}
                  src="error.svg"
                  alt="Loader"
                ></img>
              )
            ) : (
              <img
                className={`success-svg sign`}
                src="successdis.svg"
                alt="Loader"
              ></img>
            )} */}
            {/* <div className="sign-body ">
              <p className="d-flex flex-column">
                Content proof
                {statusVc &&
                inprogress !== "null" &&
                !statusVc?.CordSDRProof2024?.isValid &&
                statusVc?.CordSDRProof2024?.message ? (
                  <span className="errortxt">
                    {statusVc.CordSDRProof2024.message}
                  </span>
                ) : null}
              </p>
            </div> */}
          </div>
        </div>
      </span>
    </>
  );
};

export default VCstatus;
